// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/green_bg_projects.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/blue_bg_projects.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../images/purple_bg_projects.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payslip_title {
  font-size: 20px;

}
.arrow-img {
  margin-top: 10px !important;
  margin-left: 20px;
}

.title {
  display: flex;
}

.logo-name {
  line-height: 45px;
  padding-left: 5px;
  font-size: 14px;
  font-weight: 600;
  color: #242424;
}

.emp_input {
  display: flex;
}

.btn-group {
  display: flex !important;
  text-align: center !important;
}

.PS-title {
  color: #03030A;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 18.15px;
  letter-spacing: 0.01px;
}

.PS-title-bottomline{
  margin-top: 20px;
}

.PS-card-key h4{
color: #03030A;
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.007px;
}
.PS-card-key p{
  color: #03030A;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.007px;
  word-wrap: break-word;
}

.line {
  border: 1px solid #f0f0f0;
  margin-bottom: 20px;
}

.btn2 {
  display: flex;
  position: absolute;
  right: 25px;
  margin-top: -30px;
}

.Upbtn {
  padding: 0 30px 0 20px;
}

.leave_btn {
  border: none;
  border-radius: 5px;
}

.apply_btn {
  position: absolute;
  display: flex;
  right: 0;
  margin-top: -63px;
  margin-right: 40px;
}

.pay_img {
  margin-right: 5px;
  width: 5px;
  height: 5px;
}

.drop {
  height: 3rem;
  display: flex;
  padding-left: 485px;
}

.p-datepicker-trigger {
  color: black;
  border: 1px solid #ced4da;
  background: white;
  font-size: 1rem;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.col-dialog {
  display: flex;
}

.save_dialog_btn {
  width: 60px;
  height: 36px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff !important;
  background-color: #014FA0;
  border: none;
  float: right;
}

.cancel_dialog_btn {
  width: 80px;
  height: 35px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #a4a4a4 !important;
  background-color: rgba(216, 216, 216, 0.6);
  border: none;
}

.slash {
  width: 18px;
  height: 30px;
  color: #2e2e2e
}

.bar {
  padding-left: 6px;
  padding-right: 5px;
}

.score-box2 {
  margin-left: 7px;
}

.emp_title {
  border: 1px solid #f3f6f8;
  background-color: #f3f6f8;
  padding: 17px 0 6px 12px;
}

.emp_title1 {
  font-weight: 600;
  font-size: 22px;
}

.content {
  display: flex;
  justify-content: space-between;
}

.Savebtn {
  float: right;
}

.dropMonth {
  background-color: #006aad;
  color: #ffffff !important;
  border-radius: 15px;
}

.hr-line {
  border: 1px solid #EAEAEA;
}

.back-logo {
  width: 7px;
  height: 12px;
}

.input-grp {
  display: flex;
  justify-content: space-between;
}

.head-1 {
  border-bottom: 2px solid #F8F8F8;
  background-color: #F8F8F8;
}

.head-2 {
  margin: 20px;
  padding-top: 20px;
  color: #03030A;
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
}

.input-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.input-text {
  border: 1px solid #E3E3E7 !important;
  border-radius: 5px;
  padding-left: 35px;
}

.btn_view {
  padding: 5px 16px 5px 17px;
  border-radius: 15px;
  box-shadow: 0 2px 8px 2px rgba(230, 230, 230, 0.35);
  border: solid 1px #006aad;
  background-color: #ffffff;
  display: inline-block;
  font-size: 14px;
  color: #006bae;
  font-weight: 600;
  font-family: Inter;
  cursor: pointer;
}

.btn-view-yellow {
  border-radius: 5px;
  border: 1px solid #E6FB2D;
  background: #E6FB2D;
  color: #323232;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 15.73px;
  letter-spacing: 0.009px;
  padding: 9px 12px;
}

.btn-save {
  float: right;
  height: 30px !important;
  width: 60px !important;
  margin: 8px !important;
  color: #03030a;
  border-radius: 5px;
  box-shadow: 0 2px 8px 2px rgba(230, 230, 230, 0.35);
  border: solid 1px #e6fb2d;
  background-color: #e6fb2d;
}

.btn-black {
  color: #ffffff;
  border-radius: 5px;
  /* box-shadow: 0 2px 8px 2px #005CB9; */
  border: solid 1px #014FA0;
  background-color: #014FA0;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 15.73px;
  letter-spacing: 0.01px;
  padding: 6px 10px;
}

.btn-black:hover{
  border: solid 1px #014FA0;
  background-color: #014FA0 !important;
  color: #ffffff !important;
}

.btn-black-start {
  color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 8px 2px rgba(230, 230, 230, 0.35);
  border: solid 1px #F06E2D;
  background-color: #F06E2D;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 15.73px;
  letter-spacing: 0.01px;
  padding: 6px 10px;
}

.btn-black-start:hover{
  border: solid 1px #F06E2D;
  background-color: #F06E2D !important;
  color: #ffffff !important;
}

/* Projects */
.dropdown-input{
  color: #212121 !important;
  font-family: Inter;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 14.52px;
  letter-spacing: 0.01px;
}

.projects_status-cards_green{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-shadow: 0px 0px 24px 2px #8F888836;
  border-radius: 8px;
}
.projects_status-cards_blue{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-shadow: 0px 0px 24px 2px #8F888836;
  border-radius: 8px;
}
.projects_status-cards_purple{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-shadow: 0px 0px 24px 2px #8F888836;
  border-radius: 8px;
}
.projects-status-title{
font-size: 16px;
font-weight: 600;
line-height: 19.36px;
letter-spacing: 0.009852138347923756px;
}
.projects-status-value{
  font-size: 13px;
  font-weight: 700;
  line-height: 19.36px;
  letter-spacing: 0.009852138347923756px;
  color: #969292;
}
.projects-status-value-out_of{
  font-size: 13px;
  font-weight: 400;
  line-height: 14.52px;
  letter-spacing: 0.009852138347923756px;
  color: #969292 !important;
}
.cpb_blue .CircularProgressbar .CircularProgressbar-path{
  stroke: #493BD7;
  color: #493BD7;
}
.cpb_purple .CircularProgressbar .CircularProgressbar-path{
  stroke: #9E00C6;
}
.cpb_green .CircularProgressbar .CircularProgressbar-path{
  stroke: #659000;
}
.cpb_blue .CircularProgressbar .CircularProgressbar-trail {
  stroke: #D7D3FF;
}
.cpb_purple .CircularProgressbar .CircularProgressbar-trail {
  stroke: #F5C9FF;
}
.cpb_green .CircularProgressbar .CircularProgressbar-trail {
  stroke: #D3E899;
}
.CircularProgressbar .CircularProgressbar-text{
font-weight: 500;
line-height: 19.36px;
letter-spacing: 0.009852138347923756px;
}
.cpb_blue .CircularProgressbar .CircularProgressbar-text{
  fill: #493BD7;
  font-size: 16px;
}
.cpb_purple .CircularProgressbar .CircularProgressbar-text{
  fill: #9E00C6;
  font-size: 16px;
}
.cpb_green .CircularProgressbar .CircularProgressbar-text{
  fill: #659000;
  font-size: 16px;
}
.project-staus-value-color-blue{
  color: #493BD7;
}
.project-staus-value-color-purple{
  color: #9E00C6;
}
.project-staus-value-color-blue-green{
  color: #659000;
}
.p_blue{
  width: 86px;
  height: 63px;
  border-radius: 5px;
  background-color: #EEECFF;
  color: #493BD7;
  font-size: 24px !important;
  align-items: center;
  justify-content: center;
  text-align: center;
  display: flex;
}
.p_purple{
  width: 86px;
  height: 63px;
  border-radius: 5px;
  background-color: #FBEBFF;
  color: #9E00C6;
  font-size: 24px !important;
  align-items: center;
  justify-content: center;
  text-align: center;
  display: flex;
}
.p_green{
  width: 86px;
  height: 63px;
  border-radius: 5px;
  background-color: #E9FAC6;
  color: #659000;
  font-size: 24px !important;
  align-items: center;
  justify-content: center;
  text-align: center;
  display: flex;
}
.projects-title{
  font-weight: 500;
  color: #03030A;
  font-size: 14px;
}
.delayed{
  width: 85px;
  height: 28px;
  border-radius: 5px;
  align-items: center;
  text-align: center;
  justify-content: center;
  display: flex;
  color: #E40000;
  background-color: #FFD7D7;
  font-size: 12px;
}
.ontime{
  width: 88px;
  height: 28px;
  border-radius: 5px;
  align-items: center;
  text-align: center;
  justify-content: center;
  display: flex;
  background-color:#D9FFD3;
  color:#18AE00;
  font-size: 12px;
}
.yellow{
  color: #F3E900 !important;
}
.orange{
   color: #FFA500 !important;
}
.green{
  color: #26C10D !important;
}
.prog_bar{
  height: 6px;
  width: 90px;
  border-radius: 0px;
}
.hover-bg-color:hover{
  height: 24px;
  width: 24px;
  background-color: #D9D9D9 !important;
  background: #D9D9D9;
  border-radius: 60px;
  cursor: pointer;
}
.hover-bg-effect:hover {
  height: 18px;
  width: 18px;
  background-color: #D9D9D9 !important;
  background: #D9D9D9;
  cursor: pointer;
  border-radius: 60px;
}

/* dashboard_projects */
.dashboard_projects_status-cards{
  box-shadow: 0px 0px 24px 2px #8F888836;
border-radius: 8px;
}
.dash_pro_stats_value{
  font-size: 38px;
  font-weight: 600;
  line-height: 45.99px;
  letter-spacing: 0.009852138347923756px;
  color: #323232;
}
.dpsc_blue{
  color: #2596FF;
}
.dpsc_yellow{
  color: #F9C30A;
}
.dpsc_green{
  color: #13C020;
}
.dpsc_orange{
  color: #FF8D23;
}
.dash_pro_stats_title{
font-size: 14px;
font-weight: 400;
line-height: 16.94px;
letter-spacing: 0.009852138347923756px;
color: #03030A;
width: max-content;
}
.projects_overview_task_completion_title{
font-size: 14px;
font-weight: 600;
line-height: 16.94px;
letter-spacing: 0.008004861883819103px;
color: #03030A;
}
.projects_overview_task_completion_value{
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  letter-spacing: 0.008004861883819103px;
  color: #03030A;
}
.dpst-value{
font-size: 12px;
font-weight: 600;
line-height: 14.52px;
letter-spacing: 0.008004861883819103px;
color: #03030A;
}
.yellow_dot{
  width: 6px;
height: 6px;
opacity: 0px;
border: 1.3px solid #2D2D2D;
background-color: #E6FB2D;
border-radius: 50%;
}



/* layout */
.layout-theme-light {
  background-color: #f4f8fb !important;
}

.layout-topbar .layout-topbar-logo img {
  height: auto !important;
}

/* left nav */
.layout-menu li a {
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.01px;
  color: #FFFFFF;
  /* width: 39px; */
}

.with-width {
  width: 39px;
}


/* datatable */
.p-datatable .p-datatable-tbody>tr>td {
  padding: 10px 30px;
  color: #03030a;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01px;
}

.p-datatable .p-datatable-thead>tr>th {
  border: 0;
  /* text-align: center; */
  padding: 16px 30px;
  color: #03030a;
  background: #F8F8F8;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01px;
}

/* .p-datatable .p-column-header-content {
  justify-content: center;
} */

/* calendar */
.p-calendar-w-btn-right .p-datepicker-trigger {
  background: transparent;
  color: black;
  border: solid 1px #e3e3e7;
}
/* .p-button:enabled:active,
.p-button:not(button):not(a):not(.p-disabled):active {
  background: #005CB9;
  color: #FFFFFF;
}

.p-button:enabled:hover,
.p-button:not(button):not(a):not(.p-disabled):hover {
  background: #005CB9;
  color: #FFFFFF;
} */

.field>label {
  color: #07070e;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01px;
  margin-bottom: 1rem;
}
.passcode-in{
  color: #07070e;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01px;
  margin-bottom: 1rem;
}
  .l-heading{
    font-family: OpenSans-Regular;
    font-size: 24px;
    font-weight: 600;
    line-height: 36px;
    letter-spacing: 0.01px;
    color: #07070e;
    margin-bottom: 16px;
  }
.task_progress{
  color: #03030A;
  font-size: 15px;
  font-weight: 600;
}
.open{
  height: 12px !important;
  width: 12px !important;
  background-color: #B5E0F8;
  margin-left: 9px;
}
.inprogress{
  height: 12px !important;
  width: 12px !important;
  background-color: #F3E900;
  margin-left: 9px;
}
.delayed_status{
  height: 12px !important;
  width: 12px !important;
  background-color: #BEE868;
  margin-left: 9px;
}
.completed{
  height: 12px !important;
  width: 12px !important;
  background-color: #659000;
  margin-left: 9px;
}
.delayed_open{
  height: 12px !important;
  width: 12px !important;
  background-color: #CE0303;
  margin-left: 9px;
}
.status{
  color: #03030A;
  font-size: 12px;
  font-weight: 500;
  margin-left: 5px;
}

.on-going-projects{
  height: 12px !important;
  width: 12px !important;
  background-color: #EFAF1E;
  margin-left: 9px;
}
.completed-projects{
  height: 12px !important;
  width: 12px !important;
  background-color: #5DDE32;
  margin-left: 9px;
}
.hold-projects{
  height: 12px !important;
  width: 12px !important;
  background-color: #B1B1B1;
  margin-left: 9px;
}
.open-projects{
  height: 12px !important;
  width: 12px !important;
  background-color: #B5E0F8;
  margin-left: 9px;
}

@media (max-width: 640px) {
  .dash-drop-3{
      flex-direction: column;
  }
}


/* dashboard */

.monthly_inprogress{
  height: 12px !important;
  width: 12px !important;
  background-color: #F3E900;
  margin-left: 9px;
}
.monthly_completed{
  height: 12px !important;
  width: 12px !important;
  background-color: #26C10D;
  margin-left: 9px;
}
.monthly_delayed_open{
  height: 12px !important;
  width: 12px !important;
  background-color: #B5E0F8;
  margin-left: 9px;
}
.p-multiselect-label {
  display: block;
  white-space: normal;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mail_receive_link {
    font-family: OpenSans-Regular;
    font-weight: 600;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0.01px;
    color: #07070e;
}
.mail_receive_link:hover {
    cursor: pointer;
}
  .l-forget-text {
    font-family: OpenSans-Regular;
    font-size: 13px;
    font-weight: 600 !important;
    letter-spacing: 0.01px;
    color: #07070e;
  }
  .l-forget-text :hover {
    cursor: pointer;
  }
  .please_wait_text {
    color: #07070e !important;
    font-family: OpenSans-Regular !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    line-height: 19.5px !important;
    letter-spacing: 0.01px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/Project.css"],"names":[],"mappings":"AAAA;EACE,eAAe;;AAEjB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AACA,cAAc;AACd,kBAAkB;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,uBAAuB;AACvB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mDAAmD;EACnD,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,mDAAmD;EACnD,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uCAAuC;EACvC,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mDAAmD;EACnD,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,yDAAyD;EACzD,4BAA4B;EAC5B,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,yDAAwD;EACxD,4BAA4B;EAC5B,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,yDAA0D;EAC1D,4BAA4B;EAC5B,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;AACpB;AACA;AACA,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sCAAsC;AACtC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;AACA,gBAAgB;AAChB,oBAAoB;AACpB,sCAAsC;AACtC;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;GACG,yBAAyB;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,sCAAsC;AACxC,kBAAkB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;AACA,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sCAAsC;AACtC,cAAc;AACd,kBAAkB;AAClB;AACA;AACA,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sCAAsC;AACtC,cAAc;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,cAAc;AAChB;AACA;AACA,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sCAAsC;AACtC,cAAc;AACd;AACA;EACE,UAAU;AACZ,WAAW;AACX,YAAY;AACZ,2BAA2B;AAC3B,yBAAyB;AACzB,kBAAkB;AAClB;;;;AAIA,WAAW;AACX;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;;AAGA,cAAc;AACd;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH,aAAa;AACb;EACE,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;AACA;;;;;;;;;;GAUG;;AAEH;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;EACE;IACE,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;EACrB;AACF;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;MACI,sBAAsB;EAC1B;AACF;;;AAGA,cAAc;;AAEd;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,eAAe;AACnB;EACE;IACE,6BAA6B;IAC7B,eAAe;IACf,2BAA2B;IAC3B,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,wCAAwC;IACxC,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,iCAAiC;AACrC","sourcesContent":[".payslip_title {\n  font-size: 20px;\n\n}\n.arrow-img {\n  margin-top: 10px !important;\n  margin-left: 20px;\n}\n\n.title {\n  display: flex;\n}\n\n.logo-name {\n  line-height: 45px;\n  padding-left: 5px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #242424;\n}\n\n.emp_input {\n  display: flex;\n}\n\n.btn-group {\n  display: flex !important;\n  text-align: center !important;\n}\n\n.PS-title {\n  color: #03030A;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18.15px;\n  letter-spacing: 0.01px;\n}\n\n.PS-title-bottomline{\n  margin-top: 20px;\n}\n\n.PS-card-key h4{\ncolor: #03030A;\nfont-family: Inter;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\nline-height: normal;\nletter-spacing: 0.007px;\n}\n.PS-card-key p{\n  color: #03030A;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.007px;\n  word-wrap: break-word;\n}\n\n.line {\n  border: 1px solid #f0f0f0;\n  margin-bottom: 20px;\n}\n\n.btn2 {\n  display: flex;\n  position: absolute;\n  right: 25px;\n  margin-top: -30px;\n}\n\n.Upbtn {\n  padding: 0 30px 0 20px;\n}\n\n.leave_btn {\n  border: none;\n  border-radius: 5px;\n}\n\n.apply_btn {\n  position: absolute;\n  display: flex;\n  right: 0;\n  margin-top: -63px;\n  margin-right: 40px;\n}\n\n.pay_img {\n  margin-right: 5px;\n  width: 5px;\n  height: 5px;\n}\n\n.drop {\n  height: 3rem;\n  display: flex;\n  padding-left: 485px;\n}\n\n.p-datepicker-trigger {\n  color: black;\n  border: 1px solid #ced4da;\n  background: white;\n  font-size: 1rem;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.col-dialog {\n  display: flex;\n}\n\n.save_dialog_btn {\n  width: 60px;\n  height: 36px;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff !important;\n  background-color: #014FA0;\n  border: none;\n  float: right;\n}\n\n.cancel_dialog_btn {\n  width: 80px;\n  height: 35px;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #a4a4a4 !important;\n  background-color: rgba(216, 216, 216, 0.6);\n  border: none;\n}\n\n.slash {\n  width: 18px;\n  height: 30px;\n  color: #2e2e2e\n}\n\n.bar {\n  padding-left: 6px;\n  padding-right: 5px;\n}\n\n.score-box2 {\n  margin-left: 7px;\n}\n\n.emp_title {\n  border: 1px solid #f3f6f8;\n  background-color: #f3f6f8;\n  padding: 17px 0 6px 12px;\n}\n\n.emp_title1 {\n  font-weight: 600;\n  font-size: 22px;\n}\n\n.content {\n  display: flex;\n  justify-content: space-between;\n}\n\n.Savebtn {\n  float: right;\n}\n\n.dropMonth {\n  background-color: #006aad;\n  color: #ffffff !important;\n  border-radius: 15px;\n}\n\n.hr-line {\n  border: 1px solid #EAEAEA;\n}\n\n.back-logo {\n  width: 7px;\n  height: 12px;\n}\n\n.input-grp {\n  display: flex;\n  justify-content: space-between;\n}\n\n.head-1 {\n  border-bottom: 2px solid #F8F8F8;\n  background-color: #F8F8F8;\n}\n\n.head-2 {\n  margin: 20px;\n  padding-top: 20px;\n  color: #03030A;\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.input-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.input-text {\n  border: 1px solid #E3E3E7 !important;\n  border-radius: 5px;\n  padding-left: 35px;\n}\n\n.btn_view {\n  padding: 5px 16px 5px 17px;\n  border-radius: 15px;\n  box-shadow: 0 2px 8px 2px rgba(230, 230, 230, 0.35);\n  border: solid 1px #006aad;\n  background-color: #ffffff;\n  display: inline-block;\n  font-size: 14px;\n  color: #006bae;\n  font-weight: 600;\n  font-family: Inter;\n  cursor: pointer;\n}\n\n.btn-view-yellow {\n  border-radius: 5px;\n  border: 1px solid #E6FB2D;\n  background: #E6FB2D;\n  color: #323232;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 15.73px;\n  letter-spacing: 0.009px;\n  padding: 9px 12px;\n}\n\n.btn-save {\n  float: right;\n  height: 30px !important;\n  width: 60px !important;\n  margin: 8px !important;\n  color: #03030a;\n  border-radius: 5px;\n  box-shadow: 0 2px 8px 2px rgba(230, 230, 230, 0.35);\n  border: solid 1px #e6fb2d;\n  background-color: #e6fb2d;\n}\n\n.btn-black {\n  color: #ffffff;\n  border-radius: 5px;\n  /* box-shadow: 0 2px 8px 2px #005CB9; */\n  border: solid 1px #014FA0;\n  background-color: #014FA0;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 15.73px;\n  letter-spacing: 0.01px;\n  padding: 6px 10px;\n}\n\n.btn-black:hover{\n  border: solid 1px #014FA0;\n  background-color: #014FA0 !important;\n  color: #ffffff !important;\n}\n\n.btn-black-start {\n  color: #ffffff;\n  border-radius: 5px;\n  box-shadow: 0 2px 8px 2px rgba(230, 230, 230, 0.35);\n  border: solid 1px #F06E2D;\n  background-color: #F06E2D;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 15.73px;\n  letter-spacing: 0.01px;\n  padding: 6px 10px;\n}\n\n.btn-black-start:hover{\n  border: solid 1px #F06E2D;\n  background-color: #F06E2D !important;\n  color: #ffffff !important;\n}\n\n/* Projects */\n.dropdown-input{\n  color: #212121 !important;\n  font-family: Inter;\n  font-size: 12px !important;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14.52px;\n  letter-spacing: 0.01px;\n}\n\n.projects_status-cards_green{\n  background-image: url(../../images/green_bg_projects.png);\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  box-shadow: 0px 0px 24px 2px #8F888836;\n  border-radius: 8px;\n}\n.projects_status-cards_blue{\n  background-image: url(../../images/blue_bg_projects.png);\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  box-shadow: 0px 0px 24px 2px #8F888836;\n  border-radius: 8px;\n}\n.projects_status-cards_purple{\n  background-image: url(../../images/purple_bg_projects.png);\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  box-shadow: 0px 0px 24px 2px #8F888836;\n  border-radius: 8px;\n}\n.projects-status-title{\nfont-size: 16px;\nfont-weight: 600;\nline-height: 19.36px;\nletter-spacing: 0.009852138347923756px;\n}\n.projects-status-value{\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 19.36px;\n  letter-spacing: 0.009852138347923756px;\n  color: #969292;\n}\n.projects-status-value-out_of{\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 14.52px;\n  letter-spacing: 0.009852138347923756px;\n  color: #969292 !important;\n}\n.cpb_blue .CircularProgressbar .CircularProgressbar-path{\n  stroke: #493BD7;\n  color: #493BD7;\n}\n.cpb_purple .CircularProgressbar .CircularProgressbar-path{\n  stroke: #9E00C6;\n}\n.cpb_green .CircularProgressbar .CircularProgressbar-path{\n  stroke: #659000;\n}\n.cpb_blue .CircularProgressbar .CircularProgressbar-trail {\n  stroke: #D7D3FF;\n}\n.cpb_purple .CircularProgressbar .CircularProgressbar-trail {\n  stroke: #F5C9FF;\n}\n.cpb_green .CircularProgressbar .CircularProgressbar-trail {\n  stroke: #D3E899;\n}\n.CircularProgressbar .CircularProgressbar-text{\nfont-weight: 500;\nline-height: 19.36px;\nletter-spacing: 0.009852138347923756px;\n}\n.cpb_blue .CircularProgressbar .CircularProgressbar-text{\n  fill: #493BD7;\n  font-size: 16px;\n}\n.cpb_purple .CircularProgressbar .CircularProgressbar-text{\n  fill: #9E00C6;\n  font-size: 16px;\n}\n.cpb_green .CircularProgressbar .CircularProgressbar-text{\n  fill: #659000;\n  font-size: 16px;\n}\n.project-staus-value-color-blue{\n  color: #493BD7;\n}\n.project-staus-value-color-purple{\n  color: #9E00C6;\n}\n.project-staus-value-color-blue-green{\n  color: #659000;\n}\n.p_blue{\n  width: 86px;\n  height: 63px;\n  border-radius: 5px;\n  background-color: #EEECFF;\n  color: #493BD7;\n  font-size: 24px !important;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  display: flex;\n}\n.p_purple{\n  width: 86px;\n  height: 63px;\n  border-radius: 5px;\n  background-color: #FBEBFF;\n  color: #9E00C6;\n  font-size: 24px !important;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  display: flex;\n}\n.p_green{\n  width: 86px;\n  height: 63px;\n  border-radius: 5px;\n  background-color: #E9FAC6;\n  color: #659000;\n  font-size: 24px !important;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  display: flex;\n}\n.projects-title{\n  font-weight: 500;\n  color: #03030A;\n  font-size: 14px;\n}\n.delayed{\n  width: 85px;\n  height: 28px;\n  border-radius: 5px;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  display: flex;\n  color: #E40000;\n  background-color: #FFD7D7;\n  font-size: 12px;\n}\n.ontime{\n  width: 88px;\n  height: 28px;\n  border-radius: 5px;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  display: flex;\n  background-color:#D9FFD3;\n  color:#18AE00;\n  font-size: 12px;\n}\n.yellow{\n  color: #F3E900 !important;\n}\n.orange{\n   color: #FFA500 !important;\n}\n.green{\n  color: #26C10D !important;\n}\n.prog_bar{\n  height: 6px;\n  width: 90px;\n  border-radius: 0px;\n}\n.hover-bg-color:hover{\n  height: 24px;\n  width: 24px;\n  background-color: #D9D9D9 !important;\n  background: #D9D9D9;\n  border-radius: 60px;\n  cursor: pointer;\n}\n.hover-bg-effect:hover {\n  height: 18px;\n  width: 18px;\n  background-color: #D9D9D9 !important;\n  background: #D9D9D9;\n  cursor: pointer;\n  border-radius: 60px;\n}\n\n/* dashboard_projects */\n.dashboard_projects_status-cards{\n  box-shadow: 0px 0px 24px 2px #8F888836;\nborder-radius: 8px;\n}\n.dash_pro_stats_value{\n  font-size: 38px;\n  font-weight: 600;\n  line-height: 45.99px;\n  letter-spacing: 0.009852138347923756px;\n  color: #323232;\n}\n.dpsc_blue{\n  color: #2596FF;\n}\n.dpsc_yellow{\n  color: #F9C30A;\n}\n.dpsc_green{\n  color: #13C020;\n}\n.dpsc_orange{\n  color: #FF8D23;\n}\n.dash_pro_stats_title{\nfont-size: 14px;\nfont-weight: 400;\nline-height: 16.94px;\nletter-spacing: 0.009852138347923756px;\ncolor: #03030A;\nwidth: max-content;\n}\n.projects_overview_task_completion_title{\nfont-size: 14px;\nfont-weight: 600;\nline-height: 16.94px;\nletter-spacing: 0.008004861883819103px;\ncolor: #03030A;\n}\n.projects_overview_task_completion_value{\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14.52px;\n  letter-spacing: 0.008004861883819103px;\n  color: #03030A;\n}\n.dpst-value{\nfont-size: 12px;\nfont-weight: 600;\nline-height: 14.52px;\nletter-spacing: 0.008004861883819103px;\ncolor: #03030A;\n}\n.yellow_dot{\n  width: 6px;\nheight: 6px;\nopacity: 0px;\nborder: 1.3px solid #2D2D2D;\nbackground-color: #E6FB2D;\nborder-radius: 50%;\n}\n\n\n\n/* layout */\n.layout-theme-light {\n  background-color: #f4f8fb !important;\n}\n\n.layout-topbar .layout-topbar-logo img {\n  height: auto !important;\n}\n\n/* left nav */\n.layout-menu li a {\n  font-family: Inter;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.01px;\n  color: #FFFFFF;\n  /* width: 39px; */\n}\n\n.with-width {\n  width: 39px;\n}\n\n\n/* datatable */\n.p-datatable .p-datatable-tbody>tr>td {\n  padding: 10px 30px;\n  color: #03030a;\n  font-family: Inter;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.01px;\n}\n\n.p-datatable .p-datatable-thead>tr>th {\n  border: 0;\n  /* text-align: center; */\n  padding: 16px 30px;\n  color: #03030a;\n  background: #F8F8F8;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.01px;\n}\n\n/* .p-datatable .p-column-header-content {\n  justify-content: center;\n} */\n\n/* calendar */\n.p-calendar-w-btn-right .p-datepicker-trigger {\n  background: transparent;\n  color: black;\n  border: solid 1px #e3e3e7;\n}\n/* .p-button:enabled:active,\n.p-button:not(button):not(a):not(.p-disabled):active {\n  background: #005CB9;\n  color: #FFFFFF;\n}\n\n.p-button:enabled:hover,\n.p-button:not(button):not(a):not(.p-disabled):hover {\n  background: #005CB9;\n  color: #FFFFFF;\n} */\n\n.field>label {\n  color: #07070e;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.01px;\n  margin-bottom: 1rem;\n}\n.passcode-in{\n  color: #07070e;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.01px;\n  margin-bottom: 1rem;\n}\n  .l-heading{\n    font-family: OpenSans-Regular;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 36px;\n    letter-spacing: 0.01px;\n    color: #07070e;\n    margin-bottom: 16px;\n  }\n.task_progress{\n  color: #03030A;\n  font-size: 15px;\n  font-weight: 600;\n}\n.open{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #B5E0F8;\n  margin-left: 9px;\n}\n.inprogress{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #F3E900;\n  margin-left: 9px;\n}\n.delayed_status{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #BEE868;\n  margin-left: 9px;\n}\n.completed{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #659000;\n  margin-left: 9px;\n}\n.delayed_open{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #CE0303;\n  margin-left: 9px;\n}\n.status{\n  color: #03030A;\n  font-size: 12px;\n  font-weight: 500;\n  margin-left: 5px;\n}\n\n.on-going-projects{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #EFAF1E;\n  margin-left: 9px;\n}\n.completed-projects{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #5DDE32;\n  margin-left: 9px;\n}\n.hold-projects{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #B1B1B1;\n  margin-left: 9px;\n}\n.open-projects{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #B5E0F8;\n  margin-left: 9px;\n}\n\n@media (max-width: 640px) {\n  .dash-drop-3{\n      flex-direction: column;\n  }\n}\n\n\n/* dashboard */\n\n.monthly_inprogress{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #F3E900;\n  margin-left: 9px;\n}\n.monthly_completed{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #26C10D;\n  margin-left: 9px;\n}\n.monthly_delayed_open{\n  height: 12px !important;\n  width: 12px !important;\n  background-color: #B5E0F8;\n  margin-left: 9px;\n}\n.p-multiselect-label {\n  display: block;\n  white-space: normal;\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.mail_receive_link {\n    font-family: OpenSans-Regular;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 100%;\n    letter-spacing: 0.01px;\n    color: #07070e;\n}\n.mail_receive_link:hover {\n    cursor: pointer;\n}\n  .l-forget-text {\n    font-family: OpenSans-Regular;\n    font-size: 13px;\n    font-weight: 600 !important;\n    letter-spacing: 0.01px;\n    color: #07070e;\n  }\n  .l-forget-text :hover {\n    cursor: pointer;\n  }\n  .please_wait_text {\n    color: #07070e !important;\n    font-family: OpenSans-Regular !important;\n    font-size: 13px !important;\n    font-weight: 600 !important;\n    line-height: 19.5px !important;\n    letter-spacing: 0.01px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
